import { AppDialog } from "../components/AppDialog/AppDialog";
import styles from "./FormSubmissionDialog.module.scss";

interface IFormSubmissionDialogProps {
  visible: boolean;
  onHide: () => void;
  renderedHtml?: string | null;
  header?: string;
}

/**
 * A filled form's stored snapshot, read-only: from a reservation's details and from the
 * client's "Форми" list on their profile.
 */
export const FormSubmissionDialog = ({
  visible,
  onHide,
  renderedHtml,
  header = "Попълнена форма",
}: IFormSubmissionDialogProps) => (
  <AppDialog
    visible={visible}
    onHide={onHide}
    header={header}
    className={styles.dialog}
  >
    <div
      className={styles.content}
      // The HTML is produced server-side by PreReservationFormRenderer, which
      // HTML-encodes all text and only emits safe <br/>/<span> markup.
      dangerouslySetInnerHTML={{ __html: renderedHtml ?? "" }}
    />
  </AppDialog>
);
